import React, { Component } from 'react';

/**
 * Red de seguridad de la app.
 *
 * Dos cambios respecto a la versión anterior, pensados para un kiosko:
 *
 * 1. Se recupera SOLA. Antes esperaba a que alguien tocara un botón; en un iPad
 *    montado en una mesa de restaurante eso no pasa nunca y el menú se quedaba
 *    con la carita hasta que llegara un técnico.
 *
 * 2. Muestra el error. Antes lo escondía, y sin el mensaje no hay forma de
 *    saber qué falló: solo quedaba adivinar.
 */
class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, message: '', segundos: 5 };
    this.timer = null;
  }

  static getDerivedStateFromError(error) {
    return {
      hasError: true,
      message: (error && (error.message || String(error))) || 'Error desconocido',
    };
  }

  componentDidCatch(error, errorInfo) {
    console.error('[Kiosko] Error capturado:', error, errorInfo);

    // Cuenta atrás visible y recarga automática.
    this.timer = setInterval(() => {
      this.setState((prev) => {
        if (prev.segundos <= 1) {
          clearInterval(this.timer);
          window.location.reload();
          return { segundos: 0 };
        }
        return { segundos: prev.segundos - 1 };
      });
    }, 1000);
  }

  componentWillUnmount() {
    if (this.timer) clearInterval(this.timer);
  }

  handleReload = () => {
    if (this.timer) clearInterval(this.timer);
    window.location.reload();
  };

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <div
        style={{
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 16,
          padding: 24,
          background: '#000',
          color: '#fff',
          fontFamily: '-apple-system, system-ui, sans-serif',
          textAlign: 'center',
        }}
      >
        <div style={{ fontSize: 40 }}>⚠️</div>
        <h2 style={{ margin: 0, fontSize: 22 }}>Recargando el menú…</h2>
        <p style={{ margin: 0, opacity: 0.7 }}>
          Reiniciando en {this.state.segundos}s
        </p>

        {/* El mensaje real, para poder diagnosticar en vez de adivinar. */}
        <code
          style={{
            maxWidth: 680,
            fontSize: 12,
            opacity: 0.55,
            wordBreak: 'break-word',
            lineHeight: 1.4,
          }}
        >
          {this.state.message}
        </code>

        <button
          onClick={this.handleReload}
          style={{
            marginTop: 8,
            padding: '12px 28px',
            fontSize: 16,
            borderRadius: 999,
            border: 'none',
            background: 'rgba(255,255,255,0.22)',
            color: '#fff',
          }}
        >
          Reiniciar ahora
        </button>
      </div>
    );
  }
}

export default ErrorBoundary;
